"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CompetencyRoleLadderSchema () {
        return CompetencyRoleLadderSchema;
    },
    get CompetencyRoleLadderStatusSchema () {
        return CompetencyRoleLadderStatusSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const _useractionrecord = require("../shared/user-action-record");
const _constants = require("./constants");
const _roles = require("./roles");
const CompetencyRoleLadderStatusSchema = _zod.z.enum([
    "active",
    "archived"
]).default("active");
const CompetencyRoleLadderSchema = _base.BaseDocument.extend({
    name: _zod.z.string().max(_constants.MAX_ROLE_LADDER_NAME_LENGTH).default(""),
    // Ordered rungs (junior → senior). Membership lives here, not on the role — competency_role
    // stays frozen. A role belongs to exactly one ladder (service-code invariant).
    role_ids: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).refine((ids)=>new Set(ids.map((id)=>id.toHexString())).size === ids.length, {
        message: "role_ids must not contain duplicates"
    }).default([]),
    // Ladder-level default competencies. Merged virtually at read time under per-role overrides.
    competencies: _zod.z.array(_roles.CompetencyRoleCompetencyAssignmentSchema).refine((entries)=>new Set(entries.map((entry)=>entry.competency_id.toHexString())).size === entries.length, {
        message: "competencies must not contain duplicate competency_ids"
    }).default([]),
    status: CompetencyRoleLadderStatusSchema,
    created: _useractionrecord.UserActionRecord,
    updated: _useractionrecord.UserActionRecord
});
